export const noteDateFormat = (stringDate: string) => {
  const parts = stringDate?.split("-");

  if (parts?.length) {
    return new Date(
      parseInt(parts[2], 10),
      parseInt(parts[1], 10) - 1,
      parseInt(parts[0], 10),
    ).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }
};
